import UserResource from "./user.resource";

const userModule = angular
  .module("app.resources.user", [])
  .service("User", UserResource);

export default userModule;



// WEBPACK FOOTER //
// ./src/resources/user/user.module.js